module.exports = __webpack_public_path__ + "img/1516291245.af678b3a.jpg";